import { useState, useEffect } from "react";
import { ReactComponent as LogoSvg } from "./logo.svg";
import LogoParticles from "./LogoParticles";
import "./LandingPage.scss";

function LandingPage() {
  const [mouse, setMouse] = useState({ dx: 0, dy: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const dx = (e.clientX - window.innerWidth / 2) / (window.innerWidth / 2);
      const dy =
        (e.clientY - window.innerHeight / 2) / (window.innerHeight / 2);
      setMouse({ dx, dy });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="landing-page">
      <div
        className="landing-watermark"
        style={{
          transform: `translate(${mouse.dx * -40}px, ${mouse.dy * -40}px)`,
        }}
      >
        <LogoSvg aria-hidden="true" />
      </div>
      <div
        className="landing-logo-tilt"
        style={{
          transform: `perspective(600px) rotateX(${
            mouse.dy * -10
          }deg) rotateY(${mouse.dx * 10}deg)`,
        }}
      >
        <div className="landing-logo">
          <LogoParticles />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
